import { Row } from "reactstrap";
import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import RotatePhonePopup from "../RotatePhonePopup";
import NoInternet from '../NoInternet';
import NoDataFound2 from '../NoData2';
import { useNavigate } from "react-router-dom";
import { translateText } from "../../utils/translator";
import { useLanguage } from "../context/Languagecontext";

import category1bg from "../../img/category11bg.png";
import leftcloud from "../../img/category11leftcloud.png";
import rightcloud from "../../img/category11rightcloud.png";
import hellicon from "../../img/hellicon.png";
import heavenicon from "../../img/heavenicon.png";
import center from "../../img/category11center.png";

import HellEnglish from "../../img/Hell.png";
import HeavenEnglish from "../../img/Heaven.png";
import HellHindi from "../../img/हेल.png";
import HeavenHindi from "../../img/हेवन.png";
import HeavenTamil from "../../img/HeavenTamil.png";
import HellTamil from "../../img/HellTamil.png";
import HeavenHinglish from "../../img/HeavenHinglish.png";
import HellHinglish from "../../img/HellHinglish.png";
import QueEnglish from "../../img/Question.png";
import QueHindi from "../../img/प्रश्न.png";
import QueHinglish from "../../img/QueHinglish.png";
import QueTamil from "../../img/QueTamil.png";
import starheaven from "../../img/Starhell.svg";
import starhell from "../../img/Starheaven.svg";
import cloud from "../../img/category11cloud.svg";

import NoNet from "../../img/NoNet.png";
import NoNetDark from "../../img/NoNetDark.png";
import Nouser from "../../img/NoUserFound.png";
import NouserDark from "../../img/NoUserFoundDark.png";

import swipe from "../../audio/swipe.mp3";

// ─── Image preload utility ────────────────────────────────────────────────────
const preloadImage = (src) =>
    new Promise((resolve, reject) => {
        if (!src) { resolve(src); return; }
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = () => reject(new Error(`Failed: ${src}`));
        img.src = src;
    });

const getInitialDarkMode = () => {
    if (typeof window !== 'undefined') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
};

const LOAD_TIMEOUT_MS = 3 * 60 * 1000; // 3 minutes

const Category11 = ({ hint, uploadedImage, originalData, username, category }) => {
    const { lanText, t } = useLanguage();
    // ─── Loading / error states ───────────────────────────────────────────────
    const [noInternet, setNoInternet] = useState(false);
    const [imagesReady, setImagesReady] = useState(false);
    const [loadError, setLoadError] = useState(false);

    // ─── Dark mode + cached image states ─────────────────────────────────────
    const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode);
    const [noNetImgSrc, setNoNetImgSrc] = useState(null);
    const [noNetDarkImgSrc, setNoNetDarkImgSrc] = useState(null);
    const [noNetImgLoaded, setNoNetImgLoaded] = useState(false);
    const [noUserImgSrc, setNoUserImgSrc] = useState(null);
    const [noUserDarkImgSrc, setNoUserDarkImgSrc] = useState(null);
    const [noUserImgLoaded, setNoUserImgLoaded] = useState(false);


    // ─── Game states ──────────────────────────────────────────────────────────
    const [isOpen, setIsOpen] = useState(false); // starts false; triggered after images load
    const [showOutroCloud, setShowOutroCloud] = useState(false);
    const [starSide, setStarSide] = useState(null);


    const starPositions = [
        { x: 0, y: -35 }, { x: 0, y: 35 }, { x: -35, y: 0 }, { x: 35, y: 0 },
        { x: -25, y: -25 }, { x: 25, y: -25 }, { x: -25, y: 25 }, { x: 25, y: 25 },
        { x: -40, y: -10 }, { x: 40, y: -10 }, { x: -40, y: 10 }, { x: 40, y: 10 },
        { x: -10, y: -40 }, { x: 10, y: -40 }, { x: -10, y: 40 }, { x: 10, y: 40 },
        { x: 0, y: -55 }, { x: 0, y: 55 }, { x: -55, y: 0 }, { x: 55, y: 0 },
        { x: -40, y: -40 }, { x: 40, y: -40 }, { x: -40, y: 40 }, { x: 40, y: 40 },
        { x: -50, y: -25 }, { x: 50, y: -25 }, { x: -50, y: 25 }, { x: 50, y: 25 },
        { x: -25, y: -50 }, { x: 25, y: -50 }, { x: -25, y: 50 }, { x: 25, y: 50 },
        { x: -60, y: -15 }, { x: 60, y: -15 }, { x: -60, y: 15 }, { x: 60, y: 15 },
        { x: -15, y: -60 }, { x: 15, y: -60 }, { x: -15, y: 60 }, { x: 15, y: 60 },
        { x: -45, y: -50 }, { x: 45, y: -50 }, { x: -45, y: 50 }, { x: 45, y: 50 },
        { x: -55, y: -40 }, { x: 55, y: -40 }, { x: -55, y: 40 }, { x: 55, y: 40 },
    ];

    const swipeAudioRef = useRef(null);
    const navigate = useNavigate();
    const loadTimerRef = useRef(null);

    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram|FBAN|FBAV|Messenger|Telegram|Snapchat|Snap/i.test(ua);
    };
    const data = originalData.question;
    const avatars = [
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question11/avatar1.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question11/avatar2.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question11/avatar3.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/images/question11/avatar4.png"
    ];
    const [avatarUrl] = useState(
        () => avatars[Math.floor(Math.random() * avatars.length)]
    );
    const ques = Array.isArray(data)
        ? data.find(item => item.category === category)?.answer.heavenhellque ?? []
        : [];

    const lang = lanText || "en";

    const hellImage = lang === "hi" || lang === "mr" ? HellHindi : lang === "ta" ? HellTamil : lang === "enhi" ? HellHinglish : HellEnglish;
    const heavenImage = lang === "hi" || lang === "mr" ? HeavenHindi : lang === "ta" ? HeavenTamil : lang === "enhi" ? HeavenHinglish : HeavenEnglish;
    const queImage =
        lang === "hi" || lang === "mr"
            ? QueHindi
            : lang === "ta"
                ? QueTamil
                : lang === "enhi"
                    ? QueHinglish
                    : QueEnglish;

    // ─── Question cycling ─────────────────────────────────────────────────────
    const [currentIndex, setCurrentIndex] = useState(0);
    const [questionKey, setQuestionKey] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [translatedQues, setTranslatedQues] = useState(ques);
    const translatedQuesRef = useRef(translatedQues);
    const answersRef = useRef(answers);

    // ─── Slider state ─────────────────────────────────────────────────────────
    const [sliderX, setSliderX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const sliderRef = useRef(null);
    const dragStartX = useRef(null);
    const currentSliderX = useRef(0);
    const COMMIT_THRESHOLD = 0.45;

    // ─── Dark mode listener ───────────────────────────────────────────────────
    useEffect(() => {
        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => setIsDarkMode(e.matches);
        darkModeMediaQuery.addEventListener('change', handleChange);
        return () => darkModeMediaQuery.removeEventListener('change', handleChange);
    }, []);

    // ─── Cached image loader (NoNet + NoUser) ─────────────────────────────────
    useEffect(() => {
        let isMounted = true;

        const loadImage = (key, fallbackImg, setter, setLoaded) => {
            const cached = localStorage.getItem(key);
            if (isMounted) {
                setter(cached || fallbackImg);
                if (setLoaded) setLoaded(true);
            }
        };

        loadImage('noNetImage', NoNet, setNoNetImgSrc, setNoNetImgLoaded);
        loadImage('noNetImageDark', NoNetDark, setNoNetDarkImgSrc);
        loadImage('noUserImage', Nouser, setNoUserImgSrc, setNoUserImgLoaded);
        loadImage('noUserImageDark', NouserDark, setNoUserDarkImgSrc);

        return () => { isMounted = false; };
    }, []);

    // ─── 1. Internet check + image preload ───────────────────────────────────
    useEffect(() => {
        // Check internet first
        if (!navigator.onLine) {
            setNoInternet(true);
            return;
        }

        // Start 3-minute timeout
        loadTimerRef.current = setTimeout(() => {
            setLoadError(true);
        }, LOAD_TIMEOUT_MS);

        const imagesToLoad = [
            category1bg, leftcloud, rightcloud,
            hellicon, heavenicon, center,
            hellImage, heavenImage, queImage,
            starheaven, starhell, cloud,
            avatarUrl,
        ];

        Promise.all(imagesToLoad.map(src => preloadImage(src)))
            .then(() => {
                clearTimeout(loadTimerRef.current);
                setImagesReady(true);
                // Trigger cloud intro animation AFTER images are ready
                setIsOpen(true);
                setTimeout(() => setIsOpen(false), 2500);
            })
            .catch(() => {
                clearTimeout(loadTimerRef.current);
                setLoadError(true);
            });

        return () => clearTimeout(loadTimerRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ─── 2. Audio setup ───────────────────────────────────────────────────────
    useEffect(() => {
        swipeAudioRef.current = new Audio(swipe);
        swipeAudioRef.current.preload = "auto";
        swipeAudioRef.current.loop = false;
        swipeAudioRef.current.load();
    }, []);

    // Reset slider when question changes
    useEffect(() => {
        setSliderX(0);
        currentSliderX.current = 0;
    }, [currentIndex]);

    useEffect(() => {
        if (!ques.length) return;
        let cancelled = false;

        Promise.all(ques.map(q => translateText(q, lanText)))
            .then(results => {
                if (!cancelled) setTranslatedQues(results);
            });

        return () => { cancelled = true; };
    }, [ques.join(","), lanText]);

    useEffect(() => { translatedQuesRef.current = translatedQues; }, [translatedQues]);
    useEffect(() => { answersRef.current = answers; }, [answers]);

    // ─── Derived values ───────────────────────────────────────────────────────
    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const sx = clamp(sliderX, -1, 1);

    const TRAVEL = 110;
    const centerOffsetX = sx * TRAVEL;
    const hellScale = 0.9 + Math.max(0, -sx) * 0.2;
    const heavenScale = 0.9 + Math.max(0, sx) * 0.2;
    const gradientPercent = 50 + sx * 50;

    // ─── Commit answer ────────────────────────────────────────────────────────
    const commitAnswer = (direction) => {
        if (isAnimating) return;
        setIsAnimating(true);

        const targetX = direction === "hell" ? -1 : 1;
        setSliderX(targetX);

        setTimeout(() => {
            // ✅ Store RAW data — original question + direction (not translated strings)
            const newAnswers = [
                ...answersRef.current,
                { originalQuestion: ques[currentIndex], direction }
            ];

            setAnswers(newAnswers);
            setStarSide(direction);

            if (currentIndex < translatedQuesRef.current.length - 1) {
                setSliderX(0);
                currentSliderX.current = 0;
                setTimeout(() => {
                    swipeAudioRef.current.play();
                    setCurrentIndex(i => i + 1);
                    setQuestionKey(k => k + 1);
                    setIsAnimating(false);
                }, 600);
            } else {
                setSliderX(0);
                currentSliderX.current = 0;
                setIsAnimating(false);
                setTimeout(() => {
                    setShowOutroCloud(true);

                    // ✅ Count by direction, not by translated string
                    const hellCount = newAnswers.filter(a => a.direction === "hell").length;
                    const heavenCount = newAnswers.filter(a => a.direction === "heaven").length;
                    const result = hellCount > heavenCount ? "1" : "2";

                    setTimeout(() => {
                        const formData = {
                            originalData, hint, uploadedImage,
                            avatar: avatarUrl,
                            name: result,
                            // ✅ Pass raw answers — card will translate dynamically
                            annoyans: newAnswers,
                        };
                        sessionStorage.setItem('hellheavenData', JSON.stringify(formData));
                        navigate(
                            `/${username || ''}/${category || ''}/hellheavencard`,
                            { state: formData }
                        );
                    }, 2200);
                }, 300);
            }

            setTimeout(() => setStarSide(null), 800);
        }, 0);
    };


    // ─── Drag handlers ────────────────────────────────────────────────────────
    const onPointerDown = (e) => {
        if (isAnimating) return;
        dragStartX.current = e.clientX ?? e.touches?.[0]?.clientX;
        setIsDragging(true);
        sliderRef.current?.setPointerCapture?.(e.pointerId);
    };

    const onPointerMove = (e) => {
        if (!isDragging || dragStartX.current == null) return;
        const clientX = e.clientX ?? e.touches?.[0]?.clientX;
        const delta = clientX - dragStartX.current;
        const newX = clamp(currentSliderX.current + delta / (TRAVEL * 1.4), -1, 1);
        setSliderX(newX);
    };

    const onPointerUp = () => {
        if (!isDragging) return;
        setIsDragging(false);
        currentSliderX.current = 0;

        if (sx <= -COMMIT_THRESHOLD) commitAnswer("hell");
        else if (sx >= COMMIT_THRESHOLD) commitAnswer("heaven");
        else setSliderX(0);
    };

    const currentQuestion = translatedQues[currentIndex] ?? "";

    const allDone = answers.length === translatedQues.length && translatedQues.length > 0;

    useEffect(() => {
        const isDisabled = isAnimating || allDone || showOutroCloud;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isAnimating, allDone, showOutroCloud]);

    // ─── Resolved image sources (dark-mode aware) ─────────────────────────────
    const currentNoNetImg = isDarkMode ? noNetDarkImgSrc : noNetImgSrc;
    const currentNoUserImg = isDarkMode ? noUserDarkImgSrc : noUserImgSrc;

    // ─── Early returns ────────────────────────────────────────────────────────
    if (noInternet) {
        return (
            <NoInternet
                style={{ height: "100vh" }}
                t={t?.noData || {}}
                Nouser={currentNoNetImg}
                imgLoaded={noNetImgLoaded}
            />
        );
    }

    if (loadError) {
        return (
            <NoDataFound2
                style={{ height: "100vh" }}
                t={t?.noData2 || {}}
                Nouser={currentNoUserImg}
                username={username}
                category={category}
                imgLoaded={noUserImgLoaded}
            />
        );
    }

    // ─── Shimmer / loading screen ─────────────────────────────────────────────
    if (!imagesReady) {
        return (
            <div className="GTRegular scratch" style={{ background: "#fff", zIndex: 99999 , height : "100dvh"}}>
                <div className="h-100 d-flex justify-content-center">
                    <Row
                        className={`d-flex justify-content-center align-items-end h-100`}
                        style={{ width: "450px", maxWidth: "100vw" }}
                    >
                        {/* Title shimmer */}
                        <div style={{ height: "20%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="shimmer1" style={{ width: "85%", height: "30px", borderRadius: "10px" }} />
                        </div>

                        {/* Avatar shimmer */}
                        <div style={{ height: "33%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div
                                className="shimmer1"
                                style={{ width: "160px", height: "160px", borderRadius: "50%" }}
                            />
                        </div>

                        {/* Bottom card shimmer */}
                        <div
                            style={{
                                height: isSmallScreen ? "45%" : "40%",
                                padding: "13px 12px 0px 12px",
                                background: "#fff",
                                borderTopLeftRadius: "17px",
                                borderTopRightRadius: "17px",
                            }}
                        >
                            <div
                                style={{
                                    background: "#eeeded",
                                    borderRadius: "17px",
                                    height: "110%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "20px",
                                    padding: "16px",
                                }}
                            >
                                <div className="shimmer1" style={{ width: "90%", height: "90px", borderRadius: "14px" }} />
                                <div className="shimmer1" style={{ width: "90%", height: "27px", borderRadius: "20px" }} />
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        );
    }

    // ─── Main render ──────────────────────────────────────────────────────────
    return (
        <div className="GTRegular scratch" style={{ background: "#C3F0FF" , height : "100dvh" }}>
            <motion.div className="h-100" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                <div className="h-100 d-flex justify-content-center scratch">
                    <Row
                        className={`d-flex justify-content-center align-items-end h-100`}
                        style={{
                            width: "450px",
                            maxWidth: "100vw",
                            backgroundImage: `url(${category1bg})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            backgroundPosition: "center -45px",
                            height: "100%",
                        }}
                    >
                        {/* Title */}
                        <div style={{ height: isSmallScreen ? "20%" : "20%" }}>
                            <div
                                className="text-center h-75 mx-auto"
                                style={{
                                    maxWidth: "90vw",
                                    position: "relative",
                                    backgroundImage: `url(${cloud}), url(${cloud}), url(${cloud})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "left 10% top 20px, right 12% top 0px, right 40% bottom 15px",
                                    backgroundSize: "90px, 70px, 70px",
                                    animation: "cloudMove 1.5s linear infinite",
                                }}
                            >
                                <p
                                    className="lh-sm mx-auto ps-2 m-0 text-center GTMedium"
                                    style={{
                                        paddingTop: "40px",
                                        fontSize:
                                            t?.hellheaven?.title.length > 60
                                                ? "clamp(12px, 2vw, 14px)"
                                                : t?.hellheaven?.title.length > 40
                                                    ? "clamp(15px, 2.2vw, 16px)"
                                                    : "clamp(16px, 2.5vw, 18px)",
                                        color: "#000"
                                    }}
                                >
                                    {t?.common?.que || 'Que:'} {' '}{t?.hellheaven?.title || "Answer & decide if they're going to Heaven or Hell"}
                                </p>
                            </div>
                        </div>

                        {/* Avatar */}
                        <div
                            className="pb-2"
                            style={{
                                height: "33%",
                                width: "100%",
                                backgroundImage: `url(${avatarUrl})`,
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                            }}
                        />

                        {/* Bottom card */}
                        <div
                            style={{
                                height: isSmallScreen ? "45%" : "40%",
                                padding: "13px 12px 0px 12px",
                                background: "#C3F0FF",
                                borderTopLeftRadius: "17px",
                                borderTopRightRadius: "17px",
                            }}
                        >
                            <div
                                className="w-auto p-3 d-flex flex-column align-items-center justify-content-center pb-4"
                                style={{
                                    background: "#91E1FF",
                                    borderRadius: "17px",
                                    border: "2px dashed #5F798B",
                                    height: "110%",
                                    gap: isSmallScreen ? "10px" : "30px",
                                }}
                            >
                                {/* Question bubble */}
                                <div
                                    className="d-flex justify-content-center align-items-center position-relative"
                                    style={{ width: "100%", height: "95px" }}
                                >
                                    <svg
                                        viewBox="0 0 303 94"
                                        preserveAspectRatio="none"
                                        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0 }}
                                        fill="none"
                                    >
                                        <mask id="path-1-inside-1_548_58" fill="white">
                                            <path d="M193.5 0C207.251 5.36664e-07 218.457 10.8845 218.979 24.5078H267.506C286.671 24.508 302.207 40.0442 302.207 59.209C302.207 78.3737 286.671 93.9099 267.506 93.9102H34.7012C15.5362 93.9102 0 78.3739 0 59.209C0 40.0441 15.5362 24.5078 34.7012 24.5078H83.0215C83.5428 10.8845 94.749 0 108.5 0H193.5Z" />
                                        </mask>
                                        <path d="M193.5 0C207.251 5.36664e-07 218.457 10.8845 218.979 24.5078H267.506C286.671 24.508 302.207 40.0442 302.207 59.209C302.207 78.3737 286.671 93.9099 267.506 93.9102H34.7012C15.5362 93.9102 0 78.3739 0 59.209C0 40.0441 15.5362 24.5078 34.7012 24.5078H83.0215C83.5428 10.8845 94.749 0 108.5 0H193.5Z" fill="#EBFAFF" />
                                        <path d="M193.5 0V-2V-2V0ZM218.979 24.5078L216.98 24.5843L217.054 26.5078H218.979V24.5078ZM267.506 24.5078L267.506 22.5078H267.506V24.5078ZM267.506 93.9102V95.9102H267.506L267.506 93.9102ZM83.0215 24.5078V26.5078H84.9464L85.02 24.5843L83.0215 24.5078ZM193.5 0V2C206.172 2 216.5 12.0305 216.98 24.5843L218.979 24.5078L220.977 24.4313C220.415 9.73836 208.33 -2 193.5 -2V0ZM218.979 24.5078V26.5078H267.506V24.5078V22.5078H218.979V24.5078ZM267.506 24.5078L267.506 26.5078C285.566 26.508 300.207 41.1488 300.207 59.209H302.207H304.207C304.207 38.9396 287.775 22.5081 267.506 22.5078L267.506 24.5078ZM302.207 59.209H300.207C300.207 77.2691 285.566 91.9099 267.506 91.9102L267.506 93.9102L267.506 95.9102C287.775 95.9099 304.207 79.4783 304.207 59.209H302.207ZM267.506 93.9102V91.9102H34.7012V93.9102V95.9102H267.506V93.9102ZM34.7012 93.9102V91.9102C16.6408 91.9102 2 77.2693 2 59.209H0H-2C-2 79.4785 14.4317 95.9102 34.7012 95.9102V93.9102ZM0 59.209H2C2 41.1486 16.6408 26.5078 34.7012 26.5078V24.5078V22.5078C14.4317 22.5078 -2 38.9395 -2 59.209H0ZM34.7012 24.5078V26.5078H83.0215V24.5078V22.5078H34.7012V24.5078ZM83.0215 24.5078L85.02 24.5843C85.5004 12.0305 95.8282 2 108.5 2V0V-2C93.6698 -2 81.5851 9.73836 81.0229 24.4313L83.0215 24.5078ZM108.5 0V2H193.5V0V-2H108.5V0Z" fill="#7C9CB3" mask="url(#path-1-inside-1_548_58)" />
                                    </svg>

                                    <div
                                        className="position-absolute w-100 h-100 d-flex gap-2 flex-column align-items-center justify-content-between"
                                        style={{ zIndex: 2, padding: "10px 18px 20px" }}
                                    >
                                        <img src={queImage} style={{
                                            width:
                                                lanText === "enhi"
                                                    ? "20%"
                                                    : ["hi", "mr"].includes(lanText)
                                                        ? "12%"
                                                        : "25%"
                                        }} alt="question" />

                                        <div style={{ width: "100%", textAlign: "center", overflow: "hidden" }}>
                                            <AnimatePresence mode="wait">
                                                <motion.p
                                                    key={questionKey}
                                                    className="m-0 GTMedium text-center"
                                                    style={{ fontSize: "18px", lineHeight: "18px" }}
                                                    initial={{ opacity: 0, x: 60 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    exit={{ opacity: 0, x: -60 }}
                                                    transition={{ duration: 0.15, ease: "easeOut" }}
                                                >
                                                    {currentQuestion}
                                                </motion.p>
                                            </AnimatePresence>
                                        </div>
                                    </div>
                                </div>

                                {/* Slider area */}
                                <div
                                    className="w-100 d-flex flex-column align-items-center justify-content-end pb-4"
                                    style={{ height: isSmallScreen ? "90px" : "100px", gap: isSmallScreen ? "6px" : "10px" }}
                                >
                                    {/* Hell / Heaven label row */}
                                    <div
                                        className="rounded-pill d-flex align-items-center justify-content-between position-relative"
                                        style={{ width: "90%", height: "27px" }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                width: lanText === "hi" ? "45px" : "65px",
                                                height: "auto",
                                            }}
                                        >
                                            <img
                                                src={hellImage}
                                                alt="Hell"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "fit", // image આખી દેખાશે
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                right: 0,
                                                width: lanText === "hi" ? "55px" : "75px",
                                                height: "auto",
                                            }}
                                        >
                                            <img
                                                src={heavenImage}
                                                alt="Heaven"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "fit", // image આખી દેખાશે
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Gradient bar + draggable center */}
                                    <div
                                        ref={sliderRef}
                                        className="rounded-pill d-flex align-items-center justify-content-between position-relative"
                                        style={{
                                            width: "90%",
                                            height: "27px",
                                            background: `linear-gradient(90deg,
                                                rgba(233,59,35,1) 0%,
                                                rgba(255,255,255,1) ${gradientPercent}%,
                                                rgba(81,143,246,1) 100%)`,
                                            cursor: allDone ? "default" : isDragging ? "grabbing" : "grab",
                                            touchAction: "none",
                                            userSelect: "none",
                                        }}
                                        onPointerDown={!allDone ? onPointerDown : undefined}
                                        onPointerMove={!allDone ? onPointerMove : undefined}
                                        onPointerUp={!allDone ? onPointerUp : undefined}
                                        onPointerLeave={!allDone ? onPointerUp : undefined}
                                    >
                                        {/* Hell icon */}
                                        <motion.img
                                            src={hellicon}
                                            alt="Hell"
                                            animate={{ scale: starSide === "hell" ? 0.9 : hellScale }}
                                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                            style={{
                                                position: "absolute", left: "-13px",
                                                height: "45px", width: "45px",
                                                zIndex: 3, objectFit: "contain",
                                                pointerEvents: "none", transformOrigin: "center",
                                            }}
                                        />

                                        {/* Hell star burst */}
                                        <div style={{ position: "absolute", left: "-20px", height: "85px", width: "85px", zIndex: 4, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {starPositions.map((pos, i) => (
                                                <motion.img
                                                    key={i}
                                                    src={starheaven}
                                                    alt="star"
                                                    initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
                                                    animate={
                                                        starSide === "hell"
                                                            ? { opacity: [0, 1, 0], scale: [0, 1, 0.5], x: pos.x, y: pos.y }
                                                            : { opacity: 0, scale: 0, x: 0, y: 0 }
                                                    }
                                                    transition={{ duration: 0.6, delay: i * 0.04, ease: "easeOut" }}
                                                    style={{ position: "absolute", width: "14px", height: "14px" }}
                                                />
                                            ))}
                                        </div>

                                        {/* Center draggable knob */}
                                        <motion.img
                                            src={center}
                                            alt="Center"
                                            animate={{ x: centerOffsetX, scale: isDragging ? 1 : 1 }}
                                            transition={
                                                isDragging
                                                    ? { duration: 0 }
                                                    : { type: "spring", stiffness: 320, damping: 28 }
                                            }
                                            style={{
                                                position: "absolute", left: "50%", marginLeft: "-30px",
                                                height: "60px", width: "60px",
                                                objectFit: "contain", pointerEvents: "none",
                                                zIndex: 2, filter: "drop-shadow(0px 2px 6px rgba(0,0,0,0.18))",
                                            }}
                                        />

                                        {/* Heaven icon */}
                                        <motion.img
                                            src={heavenicon}
                                            alt="Heaven"
                                            animate={{ scale: starSide === "heaven" ? 0.9 : heavenScale }}
                                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                            style={{
                                                position: "absolute", right: "-28px",
                                                height: "85px", width: "85px",
                                                zIndex: 3, objectFit: "contain",
                                                pointerEvents: "none", transformOrigin: "center",
                                            }}
                                        />

                                        {/* Heaven star burst */}
                                        <div style={{ position: "absolute", right: "-28px", height: "85px", width: "85px", zIndex: 4, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {starPositions.map((pos, i) => (
                                                <motion.img
                                                    key={i}
                                                    src={starhell}
                                                    alt="star"
                                                    initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
                                                    animate={
                                                        starSide === "heaven"
                                                            ? { opacity: [0, 1, 1], scale: [0, 1, 1], x: pos.x, y: pos.y }
                                                            : { opacity: 0, scale: 0, x: 0, y: 0 }
                                                    }
                                                    transition={{ duration: 0.6, delay: i * 0.04, ease: "easeOut" }}
                                                    style={{ position: "absolute", width: "14px", height: "14px" }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </motion.div>

            <RotatePhonePopup excludeWhen={[]} />

            {/* CLOUD INTRO MODAL */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{ zIndex: 99999, overflow: "hidden" }}
                    >
                        <motion.img
                            src={leftcloud}
                            initial={{ x: 0 }}
                            animate={{ x: "-100%" }}
                            transition={{ duration: 2, ease: "easeInOut" }}
                            style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", objectFit: "cover" }}
                            alt="cloud-left"
                        />
                        <motion.img
                            src={rightcloud}
                            initial={{ x: 0 }}
                            animate={{ x: "100%" }}
                            transition={{ duration: 2, ease: "easeInOut" }}
                            style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", objectFit: "cover" }}
                            alt="cloud-right"
                        />
                    </motion.div>
                )}
            </AnimatePresence>

            {/* CLOUD OUTRO */}
            <AnimatePresence>
                {showOutroCloud && (
                    <motion.div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{ zIndex: 99999, overflow: "hidden" }}
                    >
                        <motion.img
                            src={leftcloud}
                            initial={{ x: "-100%" }}
                            animate={{ x: 0 }}
                            transition={{ duration: 2, ease: "easeInOut" }}
                            style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", objectFit: "cover" }}
                            alt="cloud-left"
                        />
                        <motion.img
                            src={rightcloud}
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            transition={{ duration: 2, ease: "easeInOut" }}
                            style={{ position: "absolute", top: 0, left: 0, height: "100%", width: "100%", objectFit: "cover" }}
                            alt="cloud-right"
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default Category11;